export default "__VITE_PUBLIC_ASSET__15d4f76d__"